import React, { PureComponent } from 'react';
import {
  Box,
  constants,
  FloatingPlaceholder,
  Input as CoreInput,
  Text,
} from '@match/react-component-library';

export interface InputProps {
  accept?: string;
  ariaDescribedBy?: string;
  autoCapitalize?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  form?: string;
  // getRef?: (input: HTMLInputElement) => void;
  error?: boolean;
  errorMessage?: string;
  hideBorder?: boolean;
  id: string;
  inputMode?: string;
  max?: number;
  maxLength?: number;
  min?: number;
  multiple?: boolean;
  name: string;
  onBlur?: (event?: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event?: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event?: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyUp?: (event?: React.KeyboardEvent<HTMLInputElement>) => void;
  pattern?: string;
  placeholder: string;
  readOnly?: boolean;
  required?: boolean;
  showErrors?: boolean;
  spellCheck?: boolean;
  step?: number;
  style?: object;
  success?: boolean;
  type?: string;
  uia?: string;
  value?: string | number | string[] | number[];
  width?: number | string;
}

export class OutlinedInput extends PureComponent<InputProps> {
  render() {
    const {
      error,
      errorMessage,
      ...props
    } = this.props;
    return(
      <div>
        <FloatingPlaceholder
          hideBorder
          status={error ? 'error' : 'default'}
        >
          <CoreInput
            hasError={error}
            variant="default"
            {...props}
          />
        </FloatingPlaceholder>
        {errorMessage && (
          <Box paddingLeft="medium">
            <Text
              fontSize={constants.TYPOGRAPHY.SMALLBODY}
              lineHeight={constants.LINE_HEIGHTS.SMALL}
              color={constants.SEMANTIC_COLOR_NAME.ERROR}
            >
              {errorMessage}
            </Text>
          </Box>
        )}
      </div>
    );
  }
}
